<template>
  <div>
  <div class="report-container-box">
    <div class="md-layout md-gutter">
      <div class="md-layout-item">
        <div class="header-img-container">
          <img class="header-img" src="../../public/img/la-encuesta-logo.jpg" />
        </div>
      </div>
      <div class="md-layout-item">
        <div class="md-layout md-gutter md-alignment-center-right">
        <md-button class="md-primary" @click="showContactUs = true">Contáctanos</md-button>
        </div>
      </div>
    </div>
    <div class="fixed-320" >
      <div id='div-gpt-ad-1594869143710-0'></div>
    </div>
    <div class="fixed-728" >
      <div id='div-gpt-ad-1594869239380-0'></div>
    </div>
    <dfp-slot
      path="/22051138696/LaEncuestaSemanal_Homepage_320x50"
      :size="[320, 50]" id="div-gpt-ad-1594869143710-0"
      />
    <dfp-slot
      path="/22051138696/LaEncuestaSemanal_Homepage_728x90"
      :size="[728, 90]" id="div-gpt-ad-1594869239380-0"
      />
    <div>
      <label>Seleccione la encuesta semanal a ver resultados:</label>
      <md-field>
        <md-select name="weeklySurveys" id="weeklySurveys" placeholder="Seleccionar" v-model="surveyId" @md-selected="emitSelectedSurvey" >
          <md-option v-for="option in arrayWeeklySurveys" :key="option.survey_id" :value="option.survey_id">{{ option.survey_name }}</md-option>
        </md-select>
      </md-field>
    </div>
    <div  v-if="visible == true" class="report-general-info">
      <div class="report-main-title">
        {{ surveyName }}
      </div>
      <div class="report-info-details">
        <div>
          <span>Meta encuestas:</span>&nbsp;
          <strong>
            {{ goalUsers }}
          </strong>
        </div>
        <div>
          <span>Encuestas realizadas:</span>&nbsp;
          <strong>{{ completedUsers }}</strong>
        </div>
        <div>
          <span>Inicio encuestas:</span>&nbsp; <strong>{{ beginDate }}</strong>
        </div>
        <div>
          <span>Finalización encuestas:</span>&nbsp;
          <strong>{{ endDate }}</strong>
        </div>
      </div>
        <div class="survey-top-charts">
        <div class="survey-top-charts-content">
            <pie-chart :chartData="arrayGoalData"> </pie-chart>
        </div>
        <div class="survey-top-charts-content">
            <bars-chart :chartData="arrayStatesDataData"> </bars-chart>
        </div>
    </div>
    </div>
    <question v-for="q in questions" :question="q" :key="q.q"></question>
    
  </div>
  <form>
        <md-dialog :md-active.sync="showContactUs" style="display:block">
          <md-dialog-title>Contáctanos</md-dialog-title>

          <md-dialog-content>
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                  <md-field :class="getValidationClass('firstName')">
                  <label for="first-name">Nombre</label>
                  <md-input name="first-name" id="first-name" autocomplete="given-name" v-model="form.firstName" :disabled="sending"  />
                  <span class="md-error" v-if="!$v.form.firstName.required">Please fill out this field.</span>
                  </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-field :class="getValidationClass('email')">
                  <label for="email">Email</label>
                  <md-input type="email" name="email" id="email" autocomplete="email" v-model="form.email" :disabled="sending"/>
                  <span class="md-error" v-if="!$v.form.email.required">Please fill out this field.</span>
                  <span class="md-error" v-else-if="!$v.form.email.email">Invalid email</span>
                </md-field>
              </div>
            </div>

            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <vue-tel-input v-model="form.phone" wrapperClasses="md-field" style="border:none" placeholder="Teléfono" v-on:country-changed="countryChanged"></vue-tel-input>
              </div>
            </div>

            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-field :class="getValidationClass('company')">
                <label for="company">Empresa</label>
                <md-input name="company" id="company" v-model="form.company" :disabled="sending"/>
                <span class="md-error" v-if="!$v.form.company.required">Please fill out this field.</span>
                </md-field>
              </div>
            </div>

            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-field>
                <label for="surveysuggestion">¿Qué otros temas te interesaría encuestar?</label>
                <md-input name="surveysuggestion" id="surveysuggestion" v-model="form.surveysuggestion" :disabled="sending"/>
                </md-field>
              </div>
            </div>


          </md-dialog-content>

          <md-dialog-actions>
            <md-button class="md-accent" @click="showContactUs = false;clearForm()">Cerrar</md-button>
            <md-button class="md-primary" @click="validateUser" :disabled="sending">Contáctanos</md-button>
          </md-dialog-actions>
        </md-dialog>
      </form>
  </div>
</template>

<script>
import surveysService from "@/services/Surveys/surveys";
import Question from "@/views/Surveys/Question.vue";
import BarsChart from "@/views/Surveys/bars-chart.vue";
import PieChart from "@/views/Surveys/pie-chart.vue";
import DfpSlot from "@/views/DfpSlot.vue";

import { validationMixin } from 'vuelidate';
import {
    required,
    email
  } from 'vuelidate/lib/validators';

export default {
  name: "Home",
  components: { Question, PieChart, BarsChart,DfpSlot },
  mixins: [validationMixin],
  data: function() {
    return {
      surveyName: "",
      beginDate: "",
      endDate: "",
      goalUsers: 0,
      completedUsers: 0,
      createdUsers: 0,
      inProgressUsers: 0,
      questions: [],
      goalData: {},
      arrayGoalData: [],
      statesData: {},
      arrayStatesData: [],
      arrayStatesDataData: [],
      visible: false,
      arrayWeeklySurveys: [],
      surveyId: "",
      showContactUs: false,
      sending: false,
      form: {
        firstName: null,
        company: null,
        email: null,
        country: null,
        surveysuggestion: null,
        phone: null,
        areacode: null
      },
    };
  },
  validations: {
    form: {
      firstName: {
        required
      },
      company: {
        required
      },
      country: {
        required
      },
      email: {
        required,
        email
      }
    }
  },
  methods: {
    emitSelectedSurvey: function() {
      //console.log(this.answer);
      this.getSurveyStats(this.surveyId);
    },
    getSurveyStats: function(id) {
      //call to open panel survey
      surveysService
        .getStats(id)
        .then(response => {
          console.log(response);
          this.surveyName = response.data.survey_name;
          this.beginDate = response.data.begin_date;
          this.endDate = response.data.end_date;
          this.goalUsers = response.data.goal;
          this.createdUsers = response.data.created_users;
          this.inProgressUsers = response.data.in_progress_users;
          this.completedUsers = response.data.completed_users;
          this.questions = response.data.questions_stats;
          this.visible = true;

          //goaldata
          this.goalData.completed = this.completedUsers;
          this.goalData.pending = this.goalUsers - this.completedUsers;
          this.arrayGoalData[0] = {
            name: "Completadas",
            value: this.completedUsers
          };
          this.arrayGoalData[1] = {
            name: "Pendientes",
            value: this.goalUsers - this.completedUsers
          };

          //statesData
          this.statesData.created = this.createdUsers;
          this.statesData.inProgress = this.inProgressUsers;
          this.statesData.completed = this.completedUsers;

          this.arrayStatesDataData[0] = {
            label: "Iniciada",
            value: this.createdUsers
          };

          this.arrayStatesDataData[1] = {
            label: "En Proceso",
            value: this.inProgressUsers
          };

          this.arrayStatesDataData[2] = {
            label: "Completada",
            value: this.completedUsers
          };
        })
        .catch(e => {
          console.log(e);
          this.$notifyError("Error obteniendo encuesta");
        });
    }
    , validateUser () {
        this.$v.$touch();

        if (!this.$v.$invalid) {
          this.saveUser();
        }
    }
    , getValidationClass (fieldName) {
        const field = this.$v.form[fieldName];

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          };
        }
    },
    clearForm () {
      this.$v.$reset();
      this.form.firstName = null;
      this.form.company = null;
      this.form.email = null;
      this.form.country = null;
      this.form.surveysuggestion = null;
    },
    saveUser () {
      this.sending = true;
      // Simple POST request with a JSON body using fetch

      var body = {
        "phone_number": "50299999991"
        , "webform_id": "nuevo_cliente_tigo_media_clasificacion"
        , "site": "http://laencuestasemanal.com/sw/"
        , "email": this.form.email
        , "name": this.form.firstName
        , "company": this.form.company
        , "country": this.form.country
        , "phone": `+${this.form.areacode}${this.form.phone}` 
      };

      if (this.form.surveysuggestion != null)
        body["survey_suggestion"] = this.form.surveysuggestion;

      if ('src' in this.$route.query || 'utm_source' in this.$route.query)
        body["source"] = this.$route.query['src'] || this.$route.query['utm_source'];

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      };


      fetch("http://pf.tigo.com.gt/v1/tigomedia/web/tigomedia/lead/new", requestOptions)
        .then(response => {response;})
        .then(alert('Tu información se ha enviado exitosamente!'));

      this.sending = false;
      this.clearForm();
      this.showContactUs = false;
    },
    countryChanged(country){
      this.form.country = country.name;
      this.form.areacode = country.dialCode;
    },
  },
  created: function() {
    if (this.$route.query.surveyId != null) {
      //console.log(this.$route.query);
      let surveyId = this.$route.query.surveyId;
      this.getSurveyStats(surveyId);
    } else {
      //call to open panel survey
      surveysService
        .getWeeklySurveys()
        .then(response => {
          console.log(response);
          this.arrayWeeklySurveys = response.data.surveys;
        })
        .catch(e => {
          console.log(e);
          this.$notifyError("Error obteniendo encuesta");
        });
      return;
    }
   
  }
};
</script>
<style>
.vti__dropdown-list {
  z-index: 100 !important
}
</style>